import React, {useEffect, useState} from 'react';
import {Trans} from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import {toast} from 'react-toastify';
import skincareProDao from '../../../../../dao/skincareProDao';
import {useSelector} from 'react-redux';
import FormattedDate from '../../../../../components/product/FormattedDate';
import ManualDataTable from '../../../../../components/manualdatatable/ManualDatatable';
import classnames from 'classnames';
import _indexOf from 'lodash/indexOf';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import Select from 'react-select';
import {getCategory, mapCategories} from '../../../../../utils/skincareUtils';
import smbUtils from '../../../../../utils/smbUtils';

export default function ChooseProductModal({
  showModal,
  setShowModal,
  selectedData,
  setSelectedData,
}) {
  const [categoryMapping, setCategoryMapping] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [processedParams, setProcessedParams] = useState(null);
  const [formattedData, setFormattedData] = useState({
    results: [],
    totalSize: 0,
  });
  const [queriedData, setQueriedData] = useState([]);
  const [checkedArray, setCheckedArray] = useState([]);
  const [isClickAll, setIsClickAll] = useState(true);
  const {token, customerId} = smbUtils.customerInfo(
    useSelector(state => state.components.auth.accountSummary)
  );
  let checkedQuantity = checkedArray.length;
  let totalSize = formattedData.totalSize;
  const [categorySelect, setCategorySelect] = useState('Default');
  const [productNameSelect, setProductNameSelect] = useState('');

  useEffect(() => {
    getCategory(token, customerId, 'Skincare').then(resCategory => {
      setCategoryMapping(mapCategories(resCategory));
      resCategory.unshift({
        label: (
          <Trans i18nKey="p.s.listcategory.all.category">All Category</Trans>
        ),
        value: 'Default',
      });
      setCategoryList(resCategory);
    });
  }, []);

  const listDataAPI = async () => {
    const tmp = new FormData();
    tmp.append('token', token);
    tmp.append('customerId', customerId);
    tmp.append(
      'types',
      JSON.stringify([{type1: 'Store', type2: 'SMB', type3: 'SMB_PRODUCT'}])
    );
    tmp.append('service', 'INVENTORY');

    const apiFormattedParams = _cloneDeep(processedParams);
    tmp.append('limit', apiFormattedParams.pageSize);
    tmp.append(
      'offset',
      (apiFormattedParams.pageIndex - 1) * apiFormattedParams.pageSize
    );
    delete apiFormattedParams.pageSize;
    delete apiFormattedParams.pageIndex;

    for (const [key, value] of Object.entries(apiFormattedParams)) {
      if (key === 'categoryId' && value === 'Default') {
        continue;
      }
      tmp.append(key, value);
    }

    const res = await skincareProDao.getGenericList(tmp);

    if (res.results) {
      const newRes = res.results.map(item => {
        const i18nKey = Object.keys(item.editingRevision.i18n)[0];
        return {
          id: item.id,
          categoryId: item.categoryIds[0],
          name: item.editingRevision.name,
          imageUrl: item.editingRevision.imageUrl,
          actionUrl: item.editingRevision.i18n[i18nKey].actionUrl,
          createdTime: item.createdTime,
          lastModified: item.lastModified,
          status: item.editingRevision.status,
        };
      });
      setQueriedData(prevState => [...prevState, ...newRes]);
      setFormattedData({
        ...formattedData,
        results: newRes,
        totalSize: _get(res, 'totalSize', 0),
      });
      setIsLoading(false);
      return;
    }

    toast.error(
      <Trans i18nKey="toast.error.loading.data.failed">
        Failed to load data.
      </Trans>
    );
    setIsLoading(false);
  };

  useEffect(() => {
    if (!processedParams) {
      return;
    }
    setIsLoading(true);
    listDataAPI();
  }, [processedParams]);

  const handleChooseButton = () => {
    const filteredData = selectedData.filter(item =>
      checkedArray.includes(item.id)
    );

    checkedArray.forEach(id => {
      if (!filteredData.find(item => item.id === id)) {
        const newItem = queriedData.find(item => item.id === id);
        if (newItem) {
          filteredData.push(newItem);
        }
      }
    });

    setSelectedData(filteredData);
    setCategorySelect('Default');
    setShowModal(false);
  };
  const handleProductClick = e => {
    const {value, checked} = e.target;
    setCheckedArray(prevCheckedArray => {
      if (checked) {
        return [...prevCheckedArray, parseInt(value)];
      } else {
        return prevCheckedArray.filter(s => s !== parseInt(value));
      }
    });
  };
  const handleProductClickAll = e => {
    if (e.target.checked) {
      formattedData.results.map(s => {
        if (_indexOf(checkedArray, s.id) === -1)
          setCheckedArray(checkedArray => checkedArray.concat(s.id));
      });
    } else {
      setCheckedArray([]);
    }
  };
  const handleCategorySelect = value => {
    setCategorySelect(value);
  };
  const handleProductNameSelect = searchValue => {
    setProductNameSelect(searchValue);
  };

  useEffect(() => {
    setIsClickAll(true);
    formattedData.results.map(s => {
      if (_indexOf(checkedArray, s.id) === -1) setIsClickAll(false);
    });
  }, [checkedArray, formattedData]);

  useEffect(() => {
    setCheckedArray(selectedData.map(item => item.id));
  }, [selectedData]);

  const columns = [
    {
      Header: (
        <div className={'text-center'}>
          <input
            type="checkbox"
            onChange={e => {
              handleProductClickAll(e);
            }}
            checked={isClickAll}
          />
        </div>
      ),
      accessor: 'id',
      disableSortBy: true,
      style: {width: '5%', textAlign: 'center'},
      Cell: ({
        cell: {
          row: {original},
        },
      }) => (
        <div className="text-center">
          <input
            type="checkbox"
            value={original.id}
            onClick={e => {
              handleProductClick(e);
            }}
            checked={_indexOf(checkedArray, parseInt(original.id)) !== -1}
          />
        </div>
      ),
    },
    {
      Header: <Trans i18nKey="p.s.addoreditskincareroutine.image">Image</Trans>,
      accessor: 'imageUrl',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <img
          alt=""
          src={value}
          style={{height: '50px', display: 'block', margin: '0 auto'}}
        />
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.addoreditskincareroutine.category">Category</Trans>
      ),
      accessor: 'categoryId',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
      Cell: ({cell: {value}}) => categoryMapping[value],
    },
    {
      Header: (
        <Trans i18nKey="p.s.addoreditskincareroutine.product.Name">
          Product Name
        </Trans>
      ),
      disableSortBy: true,
      accessor: 'name',
      style: {width: '10%', textAlign: 'center', wordBreak: 'break-word'},
    },
    {
      Header: (
        <Trans i18nKey="p.s.addoreditskincareroutine.creation">Creation</Trans>
      ),
      accessor: 'createdTime',
      disableSortBy: true,
      style: {width: '12.5%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <div className="text-right">
          <FormattedDate time={value} type={'long'} />
        </div>
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.addoreditskincareroutine.modification">
          Modification
        </Trans>
      ),
      accessor: 'lastModified',
      disableSortBy: true,
      style: {width: '12.5%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <div className="text-right">
          <FormattedDate time={value} type={'long'} />
        </div>
      ),
    },
  ];

  return (
    <Modal
      centered
      show={showModal}
      onHide={() => {
        setCategorySelect('Default');
        setShowModal(false);
      }}
      size="xl"
    >
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey="p.s.addoreditskincareroutine.choose.skincare.product">
            Choose Skincare Product
          </Trans>
        </Modal.Title>
        <div
          className="input-group d-block flex-grow-0"
          style={{color: 'transparent', width: '35%'}}
        >
          <div className="input-group-prepend">
            <div
              className="input-group-text"
              style={{
                marginRight: '-1px',
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
              }}
            >
              <i className={'la la-search'} />
            </div>
            <input
              size="large"
              className={'form-control'}
              style={{
                borderTopLeftRadius: '0',
                borderBottomLeftRadius: '0',
              }}
              name="searchInput"
              value={productNameSelect || ''}
              onChange={e => handleProductNameSelect(e.target.value)}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className="control-category"
          style={{display: 'flex', alignItems: 'center'}}
        >
          <div style={{width: '180px'}}>
            <Select
              options={categoryList}
              defaultValue={categoryList.find(
                category => category.value === 'Default'
              )}
              onChange={item => handleCategorySelect(item.value)}
              isSearchable={false}
              isClearable={false}
              placeholder={
                <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
              }
            />
          </div>
          <div className="select-product-records" style={{marginLeft: 'auto'}}>
            <Trans i18nKey="p.s.addoreditskincareroutine.select.pageindex">
              {{checkedQuantity}} selected / Total {{totalSize}}
            </Trans>
          </div>
        </div>
        <ManualDataTable
          isLoading={isLoading}
          columns={columns}
          data={formattedData.results}
          totalSize={formattedData.totalSize}
          initState={{
            sortBy: {id: 'lastModified', desc: true},
            pageSize: 5,
            pageIndex: 1,
          }}
          extParams={{
            categoryId: categorySelect,
            name: productNameSelect,
          }}
          setProcessedParams={setProcessedParams}
          isScrollX={true}
          isModalSetting={true}
        />
      </Modal.Body>
      <Modal.Footer className="text-right">
        <div className="d-flex justify-content-end flex-fill">
          <div className="text-center margin-top-10">
            <div
              className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10 cursor-pointer"
              onClick={() => {
                setCategorySelect('Default');
                setShowModal(false);
              }}
            >
              <Trans i18nKey="p.s.addoreditskincareroutine.close">Close</Trans>
            </div>
          </div>
          <div
            className="text-center margin-top-10"
            style={{position: 'relative'}}
          >
            <div
              className={classnames({
                btn: true,
                'btn-primary': true,
                'kt-margin-r-10': true,
                'kt-margin-b-10': true,
                'kt-spinner': true,
                'kt-spinner-v2': true,
                'kt-spinner--center': true,
                'kt-spinner--sm': true,
                'cursor-pointer': true,
              })}
              onClick={handleChooseButton}
            >
              <Trans i18nKey="p.s.addoreditskincareroutine.choose">
                Choose
              </Trans>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
